export const themes = [
    { name: 'LIGHT PINK', value: 25 },
    { name: 'PINK-WHITE-RED', value: 75 },
    { name: 'PINK-RED', value: 100 },
    { name: 'LIGHT PINK', value: 150 },
    { name: 'ORANGY AUTUMN', value: 256 },
    { name: 'AQUA BLUES', value: 175 },
    // { name: 'AQUA', value: 450 },
    { name: 'GREEN/PINK', value: 350 },
    { name: 'BLOOD', value: 5 },
    { name: 'PINK', value: 15 },
    { name: 'PINK-WHITE', value: 32 }
    // { name: 'Torquise', value: 495 }
  ];
  